// extracted by mini-css-extract-plugin
export default {"suffix":"Detail_suffix__O0w-s","store-summary-wrapper":"Detail_store-summary-wrapper__99tB2","item":"Detail_item__3bd19"};